import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const NavbarRoutes = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(true);
  const location = useLocation();

  React.useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        setIsLargeScreen(window.innerWidth >= 1085);
      }
    };
    
    // Initial check
    if (typeof window !== 'undefined') {
      handleResize();
    }
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'How It Works', path: '/how-it-works' },
    { name: 'Why Join', path: '/why-join' },
    { name: 'Petitioner DAO', path: '/dao' },
    { name: 'Impact', path: '/impact' },
    { name: 'Merch', path: '/merch' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="fixed w-full bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src="/images/logo.png" alt="Petition.io" className="h-12 w-auto object-contain" />
          </Link>

          {/* Desktop Navigation */}
          {isLargeScreen && (
            <div className="flex space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
              >
                <motion.span
                  whileHover={{ scale: 1.05 }}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive(link.path)
                      ? 'bg-primary-blue text-white'
                      : 'text-neutral-dark hover:bg-gray-100'
                  }`}
                >
                  {link.name}
                </motion.span>
              </Link>
            ))}
          </div>
          )}

          {/* CTA Button */}
          {isLargeScreen && (
            <div>
            <a href="https://app.petition.io" target="_blank" rel="noopener noreferrer">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-6 py-2 bg-cta-orange text-white rounded-full font-semibold hover:bg-orange-600 transition-all shadow-lg hover:shadow-xl"
              >
                Launch dApp
              </motion.button>
            </a>
          </div>
          )}

          {/* Mobile menu button */}
          {!isLargeScreen && (
            <button
            onClick={() => setIsOpen(!isOpen)}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <svg
              className="h-6 w-6 text-neutral-dark"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
          )}
        </div>

        {/* Mobile menu */}
        {isOpen && !isLargeScreen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden py-4"
          >
            <div className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive(link.path)
                      ? 'bg-primary-blue text-white'
                      : 'text-neutral-dark hover:bg-gray-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a href="https://app.petition.io" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="w-full">
                <button className="w-full px-4 py-2 bg-cta-orange text-white rounded-lg font-semibold text-center hover:bg-orange-600 transition-colors">
                  Launch dApp
                </button>
              </a>
            </div>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default NavbarRoutes;
